import {
  Border,
  BorderBottomWidth,
  BorderBottomStyle,
  BorderBottomColor,
  CssVariable,
} from '@wix/css-property-parser';

export type BorderParsedValue = {
  borderWidth: string | null;
  borderStyle: string | null;
  borderColor: string | null;
};

export const parseBorderValue = (value: string): BorderParsedValue => {
  const border = Border.parse(value);

  const values: BorderParsedValue = {
    borderWidth: null,
    borderStyle: null,
    borderColor: null,
  };

  if (!border) {
    return values;
  }

  if ('type' in border && border.type === 'variable') {
    Object.keys(values).forEach((key) => {
      values[key as keyof BorderParsedValue] = CssVariable.toCSSValue(border);
    });

    return values;
  }

  if ('width' in border && border.width) {
    values.borderWidth = BorderBottomWidth.toCSSValue(border.width);
  }
  if ('style' in border && border.style) {
    values.borderStyle = BorderBottomStyle.toCSSValue(border.style);
  }
  if ('color' in border && border.color) {
    values.borderColor = BorderBottomColor.toCSSValue(border.color);
  }

  return values;
};
